import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import {
  ADD_VEHICLE_BUTTON_LABEL,
  VEHICLE_DESCRIPTION_PLACEHOLDER
} from 'components/MyGarage2.0/constants'
import { ActionButton } from '../../../SharedStyles'

const EmptyVehiclePlaceholder = ({ handleAddNewVehicle }) =>
  <Wrapper>
    <CustomIcon asset="garage-vehicle-placeholder" />
    <Description>
      { VEHICLE_DESCRIPTION_PLACEHOLDER }
    </Description>
    <AddVehicleButton
      full
      narrow
      data-at-add-a-vehicle-button
      onClick={ handleAddNewVehicle }>
      { ADD_VEHICLE_BUTTON_LABEL }
    </AddVehicleButton>
  </Wrapper>

export default EmptyVehiclePlaceholder

EmptyVehiclePlaceholder.propTypes = {
  handleAddNewVehicle: PropTypes.func
}

const Wrapper = styled.div`
  grid-area: EmptyVehiclePlaceholder;
  max-height: 250px;
  padding: 35px 71px 33px;
  background: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.light_grey};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-self: flex-start;
  ${Media.mobile`
    padding: 32px 20px;
  `}
`

const CustomIcon = styled(Icon)`
  width: 100%;
  height: 47px;
  margin-bottom: 31px;
`

const Description = styled.p`
  ${Mixin.font.GothamBook(13, 400, 16)};
  color: ${Theme.colors.dark_grey};
  margin: 0 0 31px 0;
  text-align: center;
  opacity: 0.8;
`

const AddVehicleButton = styled(ActionButton)`
  text-transform: uppercase;
`
